import { render, staticRenderFns } from "./sign-in-sso.vue?vue&type=template&id=c8d75c8a&scoped=true&"
import script from "./sign-in-sso.vue?vue&type=script&lang=js&"
export * from "./sign-in-sso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d75c8a",
  null
  
)

export default component.exports